module.exports = __webpack_public_path__ + "static/media/19.061d3ead.svg";